import { render, staticRenderFns } from "./integralmall.vue?vue&type=template&id=5956a303&scoped=true&"
import script from "./integralmall.vue?vue&type=script&lang=js&"
export * from "./integralmall.vue?vue&type=script&lang=js&"
import style0 from "./integralmall.vue?vue&type=style&index=0&id=5956a303&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5956a303",
  null
  
)

export default component.exports